import {
  Building, Building2, CalendarDays, Combine, Contact, FileStack, FileText, GitMerge, Link2, MapPin, Sprout, Truck, Wheat,
} from 'lucide-react'
import type { HubItemDef } from '../../features/cadastros/CadastroHubLayout'

/** As abas do hub de Cadastros da Logística. Cada entrada declara a key que o
 *  SERVIDOR exige na rota correspondente.
 *
 *  Os cadastros gerais, Clientes, Pessoas, Frota, Locais, Ativos e Feriados, moraram
 *  no Administrativo de 24/10 a 26/10/2026 e voltaram para cá a pedido do Samuel:
 *  "a maioria desses daqui é logística". Vêm primeiro, na ordem que ele falou. */
export const cadastrosDaLogistica: HubItemDef[] = [
  { labelKey: 'cadastros.cadastrosHub.customers', to: '/logistica/cadastros/customers', icon: Building2, permission: 'master_data.view' },
  { labelKey: 'cadastros.cadastrosHub.people', to: '/logistica/cadastros/personnel', icon: Contact, permission: 'master_data.view' },
  { labelKey: 'cadastros.cadastrosHub.fleet', to: '/logistica/cadastros/fleet', icon: Truck, permission: 'master_data.view' },
  { labelKey: 'cadastros.cadastrosHub.places', to: '/logistica/cadastros/places', icon: MapPin, permission: 'master_data.view' },
  { labelKey: 'cadastros.cadastrosHub.assets', to: '/logistica/cadastros/assets', icon: Wheat, permission: 'master_data.view' },
  // Feriados é calendário: o que ele muda é a apuração de hora extra da Jornada.
  { labelKey: 'cadastros.cadastrosHub.holidays', to: '/logistica/cadastros/feriados', icon: CalendarDays, permission: 'master_data.view' },
  // O cliente do HUB agrupa os clientes do Protheus, no esquema de Serviços
  // (Samuel, 08/10/2026).
  { labelKey: 'cadastros.cadastrosHub.hubCustomers', to: '/logistica/cadastros/clientes-hub', icon: Building, permission: 'master_data.view' },
  { labelKey: 'cadastros.cadastrosHub.contracts', to: '/logistica/cadastros/contratos', icon: FileText, permission: 'contracts.view' },
  // Logo abaixo de Contratos, porque é o par dele (Samuel, 21/08/2026).
  // Espelho do Protheus, só leitura. A permissão é a da rota: o servidor gateia
  // /subcontratos por shipments.view porque a lista nasceu para a Frente.
  { labelKey: 'cadastros.cadastrosHub.subcontracts', to: '/logistica/cadastros/subcontratos', icon: FileStack, permission: 'shipments.view' },
  // Logo depois de Subcontratos, porque é o par dele: aquele é o lado transporte
  // da safra, este é o lado campo. Mesma permissão, pelo mesmo motivo.
  { labelKey: 'cadastros.cadastrosHub.fieldSheets', to: '/logistica/cadastros/planilhas', icon: Sprout, permission: 'shipments.view' },
  // Fecha o trio da safra, e é o que AMARRA os outros dois: a frente do ERP
  // nomeia o par exato de cada trilho, e é o único caminho sem ambiguidade entre
  // a planilha de campo e o subcontrato de transporte. Ícone de junção pelo mesmo
  // motivo. Mesma permissão dos dois acima.
  { labelKey: 'cadastros.cadastrosHub.workFronts', to: '/logistica/cadastros/frentes', icon: GitMerge, permission: 'shipments.view' },
  // Duplas mora em Cadastros desde 04/09/2026 (Samuel); Conjuntos é a tela de abas
  // da Operação.
  { labelKey: 'cadastros.cadastrosHub.pairs', to: '/logistica/cadastros/duplas', icon: Link2, permission: 'sets.view' },
  // Serviços (Samuel, 24/09/2026): o nome que a operação dá a um grupo de
  // descrições de serviço do ERP, como Prancha. Ícone de junção porque é isso que
  // a tela faz, várias descrições num serviço só.
  { labelKey: 'cadastros.cadastrosHub.services', to: '/logistica/cadastros/servicos', icon: Combine, permission: 'master_data.view' },
]
